export default "__VITE_ASSET__wuxMrsIS__"